import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import AgGridTable from "../utilities/AgGridTable";
import FormPageHeader from "../utilities/FormPageHeader";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon/FuseSvgIcon";
import customStyles from "app/shared-components/SelectCustomStyle";
import ListPageHeader from "../utilities/ListPageHeader";
import Select from "react-select";
import {
  Button,
  Select as MuiSelect,
  TextField,
  FormControl,
  MenuItem,
  Stack,
  Tooltip,
  Checkbox,
  Dialog,
  DialogContent,
  DialogActions,
  DialogContentText,
  DialogTitle,
  AppBar,
  Toolbar,
  Typography,
  IconButton,
} from "@mui/material";
import CustomDatePicker from "../utilities/CustomDatePicker";
import ViewFinanceInvoiceData from "./ViewFinanceInvoiceData";
// import moment from "moment";
// import ViewProformaInvoiceData from "./ViewProformaInvoiceData";

const initialData = [
  {
    proformalNo: "2307019",
    proformaDate: "29-07-2023",
    customer: "30001",
    name: "UNIVERSAL TRADING COMPANY",
    pIValue: "64,500.00",
    containerNo: "HCIU2100788",
    intlCntrNo: "UT512",
    actualLoadingDate: "18-09-2023",
    actualLoadingWeek: "38",
    actualInvoiceDate: "18-09-2023",
    nmercbl: "64,500",
    saleInvoiceNo: "23080119",
    nmepbl: "47,300",
    purchaseInvoice: "",
    purchaseInvoiceValue: "",
    differnce: "47,300.00",
    recon: "",
    financed: "",
    orders: [
      {
        abNumber: "1306773 01",
        commisssionName: "UT2926701-NK-KIT-RET1",
        abValue: "19,200.00",
        orderType: "RETAIL",
        material: "RET-KIT-NK-001",
        listPrice: "25,600.00",
        RCBL: "19,200",
        PBL: "14,099.99",
        vendorInvDate: "2023-09-18",
        vendorInvNo: "4015362",
      },
      {
        abNumber: "1306789 01",
        commisssionName: "UT2926701-NK-KIT-RET2",
        abValue: "15,200.00",
        orderType: "RETAIL",
        material: "RET-KIT-NK-001",
        listPrice: "20,600.00",
        RCBL: "15,200",
        PBL: "11,099.99",
        vendorInvDate: "2023-09-18",
        vendorInvNo: "4015362",
      },
    ],
  },
  {
    proformalNo: "2307017",
    proformaDate: "25-07-2023",
    customer: "30003",
    name: "UNIVERSAL TRADING COMPANY",
    pIValue: "64,500.00",
    containerNo: "HCIU2100807",
    intlCntrNo: "UT515",
    actualLoadingDate: "14-09-2023",
    actualLoadingWeek: "38",
    actualInvoiceDate: "14-09-2023",
    nmercbl: "64,500",
    saleInvoiceNo: "23080119",
    nmepbl: "47,300",
    purchaseInvoice: "",
    purchaseInvoiceValue: "",
    differnce: "47,300.00",
    recon: "",
    financed: "",
  },
  {
    proformalNo: "2307021",
    proformaDate: "24-07-2023",
    customer: "30003",
    name: "UNIVERSAL TRADING COMPANY",
    pIValue: "64,500.00",
    containerNo: "HCIU2100754",
    intlCntrNo: "UT512",
    actualLoadingDate: "15-09-2023",
    actualLoadingWeek: "38",
    actualInvoiceDate: "15-09-2023",
    nmercbl: "64,500",
    saleInvoiceNo: "23080119",
    nmepbl: "47,300",
    purchaseInvoice: "",
    purchaseInvoiceValue: "",
    differnce: "47,300.00",
    recon: "",
    financed: "",
    orders: [
      {
        abNumber: "1306773 01",
        commisssionName: "UT2926701-NK-KIT-RET1",
        abValue: "19,200.00",
        orderType: "RETAIL",
        material: "RET-KIT-NK-001",
        listPrice: "25,600.00",
        RCBL: "19,200",
        PBL: "14,099.99",
        vendorInvDate: "2023-09-18",
        vendorInvNo: "4015362",
      },
      {
        abNumber: "1306789 01",
        commisssionName: "UT2926701-NK-KIT-RET2",
        abValue: "15,200.00",
        orderType: "RETAIL",
        material: "RET-KIT-NK-001",
        listPrice: "20,600.00",
        RCBL: "15,200",
        PBL: "11,099.99",
        vendorInvDate: "2023-09-18",
        vendorInvNo: "4015362",
      },
    ],
  },
];

const FinanceInvoice = () => {
  const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.financeInvoice}`;
  const generateSIPIUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.generateInvoice}`;
  const gridRef = useRef();
  const [error, setError] = useState("");
  const [successMsg, setSuccessMsg] = useState();
  const [rowData, setRowData] = useState([]);
  const [gridApi, setGridApi] = useState(null);
  const [snackState, setSnackState] = useState(false);
  const [checkSubmit, setCheckSubmit] = useState(false);
  const [updateData, setUpdateData] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [btnDisable, setBtnDisable] = useState(true);
  const [toError, setToError] = useState();
  const [toDate, setToDate] = useState();
  const [fromDate, setFromDate] = useState();
  const [rowEvent, setRowEvent] = useState("");
  const [open, setOpen] = useState(false);
  const [invoice, setInvoice] = useState({});
  const navigate = useNavigate();

  const ReconCheckboxRenderer = (props) => {
    return (
      <Checkbox
        size="small"
        defaultChecked={props.data.recon}
        sx={{ padding: 0 }}
      />
    );
  };
  const FinancedCheckboxRenderer = (props) => {
    return (
      <Checkbox
        size="small"
        defaultChecked={props.data.financed}
        sx={{ padding: 0 }}
      />
    );
  };
  const ViewCheckboxRenderer = (props) => {
    return <FuseSvgIcon>heroicons-solid:eye</FuseSvgIcon>;
  };

  const [columnDefs, setColumnDefs] = useState([
    { field: "proformaNo", cellRenderer: "agGroupCellRenderer" },
    { field: "proformaDate" },
    { field: "companyId", headerName: "Customer" },
    { field: "companyName", headerName: "Name", minWidth: 250 },
    { field: "pIValue" },
    { field: "actualContainerNumber", headerName: "Container No" },
    { field: "containerNo", headerName: "Internal Container Number" },
    { field: "actualLoadingDate" },
    { field: "actualLoadingWeek" },
    { field: "actualInvoiceDate", minWidth: 250 },
    { field: "nmercbl", minWidth: 200, headerName: "NME RCBL" },
    { field: "saleInvoiceNo", minWidth: 200 },
    { field: "nmepbl", minWidth: 200, headerName: "NME PBL" },
    { field: "purchaseInvoice", minWidth: 200 },
    { field: "purchaseInvoiceValue", minWidth: 250 },
    { field: "differnce", minWidth: 180 },
    {
      field: "recon",
      minWidth: 150,
      headerName: "RECON?",
      cellRenderer: ReconCheckboxRenderer,
    },
    {
      field: "financed",
      minWidth: 150,
      cellRenderer: FinancedCheckboxRenderer,
    },
    { field: "View", minWidth: 150, cellRenderer: ViewFinanceInvoiceData },
  ]);

  const autoSizeAll = useCallback(
    (value) => {
      const allColumnIds = [];
      gridRef.current.columnApi.getColumns().forEach((column) => {
        allColumnIds.push(column?.getId());
      });
      gridRef.current.columnApi.autoSizeColumns(allColumnIds, value);
    },
    [rowData]
  );

  const onGridReady = useCallback((params) => {
    var columnToolPanel = gridRef.current.api.getToolPanelInstance("columns");
    columnToolPanel.expandColumnGroups();
    autoSizeAll(false);
  }, []);

  const onSelectionChanged = (params) => {
    setSelectedRows(params.api.getSelectedRows());
  };

  const handleClose = () => {
    setOpen(false);
  };

  const getFinance = async () => {
    const model = {
      customer: "",
      customerName: "",
      fromDate: "",
      toDate: "",
      containerNo: "",
      internalContainerNo: "",
      pageNo: 0,
      pageSize: 10,
    };
    try {
      const list = await OAuthService.addData(url, model);
      let finance = list.data.content;
      setRowData(finance);
    } catch (error) {
      setError(error.message);
    }
  };

  useEffect(() => {
    getFinance();
  }, []);

  const detailCellRendererParams = useMemo(() => {
    return {
      detailGridOptions: {
        rowSelection: "multiple",
        enableRangeSelection: true,
        pagination: true,
        rowGroupPanelShow: "always",
        paginationPageSize: 10,
        columnDefs: [
          { field: "abNumber" },
          { field: "commissionName" },
          { field: "abValue" },
          { field: "material" },
          { field: "listPrice" },
          { field: "RCBL" },
          { field: "PBL" },
          { field: "vendorInvDate" },
          { field: "vendorInvNo" },
          { field: "recon", headerName: "RECON?" },
        ],
        defaultColDef: {
          floatingFilter: true,
          filter: "agMultiColumnFilter",
          flex: 1,
          editable: false,
          enableRowGroup: true,
          cellStyle: { borderRight: "1px solid #757575" },
        },
      },
      getDetailRowData: (params) => {
        params.successCallback(params.data.orders);
      },
    };
  }, []);

  const isRowMaster = useMemo(() => {
    return (dataItem) => {
      return dataItem ? dataItem.orders?.length > 0 : false;
    };
  }, []);

  const handleClickSalesInvoice = () =>{
    navigate(`/editVoucher/${invoice.salesInvoice}`)
  }
  const handleClickPurchaseInvoice = () =>{
    navigate(`/editVoucher/${invoice.purchaseInvoice}`)
  }

  const financeInputFields = () => {
    const handleCreateSubmit = async () => {
      const url = `${generateSIPIUrl}/${selectedRows[0].id}`;
      const res = await OAuthService.addData(url, null);
      setInvoice(res.data);
      setOpen(true);
    };

    const handleCreatePISubmit = () => {
      const docDate = new Date();
      const vouchertype = "65648fea5ecb7469b6ef27ca";
      const refType = "NO_REFERENCE";

      navigate("/addVoucher", {
        state: { docDate: docDate, vouchertype: vouchertype, refType: refType },
      });
    };

    const handleCreateSISubmit = () => {
      const docDate = new Date();
      const vouchertype = "65648fea5ecb7469b6ef27ce";
      const refType = "NO_REFERENCE";

      navigate("/addVoucher", {
        state: { docDate: docDate, vouchertype: vouchertype, refType: refType },
      });
    };

    return (
      <>
        <Tooltip title={"Create Sales Invoice"}>
          <Button
            variant="contained"
            color="warning"
            style={{ marginLeft: "4px" }}
            disabled={btnDisable}
            onClick={handleCreateSubmit}
          >
            Create Invoice
          </Button>
        </Tooltip>
        <Tooltip title={"Print Financing Invoice"}>
          <Button
            variant="contained"
            color="warning"
            style={{ marginLeft: "4px" }}
            // onClick={handlePrint}
          >
            <FuseSvgIcon>heroicons-outline:printer</FuseSvgIcon>
          </Button>
        </Tooltip>
      </>
    );
  };

  useEffect(() => {
    if (selectedRows.length > 0) {
      setBtnDisable(false);
    } else {
      setBtnDisable(true);
    }
  }, [selectedRows]);

  return (
    <>
      <ListPageHeader
        componentName="Financing / Invoicing"
        headerInputFields={financeInputFields()}
        // onBtExport={onBtExport}
        // handlePurge={handlePurge}
        pageName="Financing / Invoicing"
        error={error}
        // deleteDisable={deleteDisable}
        successMsg={successMsg}
        gridRef={gridRef}
        snackState={snackState}
        showPaginationDropdown={false}
      />

      <Stack direction={"row"} className="mb-10 md:px-16 self-end">
        <div className="flex flex-row">
          <div className="flex flex-row justify-between items-baseline">
            <>
              {/* <FormControl className={"flex"} size="small">
                <label className="pt-12 min-w-fit">Page Size</label>
                <MuiSelect
                  // onChange={onPageSizeChanged}
                  className="ml-5 h-fit min-w-[100px]"
                  // value={selectedSize}
                  id="page-size"
                  // native={true}
                  inputProps={{
                    sx: { padding: "10px" },
                  }}
                >
                  <MenuItem value="10">10</MenuItem>
                  <MenuItem value="20">20</MenuItem>
                  <MenuItem value="50">50</MenuItem>
                  <MenuItem value="100">100</MenuItem>
                </MuiSelect>
              </FormControl> */}

              {/* <Stack className="ml-10">
                                    <label className="pt-12 min-w-fit">Company</label>
                                    <TextField
                                        name='company'
                                        value={company}
                                        onChange={handlechangecompany}
                                        inputProps={{
                                            sx: { 'padding': '10px' },
                                        }}
                                    />
                                </Stack> */}

              <Stack className="ml-10">
                <label className="pt-12 min-w-fit">Actual Invoice Date</label>
                <Select
                  name="actualInvoiceDate"
                  className=" min-w-[150px]"
                  // className="w-[85px] h-[20px]"
                  // value={}
                  // onChange={}
                  // options={}
                  styles={customStyles("", "", "0px")}
                />
              </Stack>
              <Stack className="ml-10">
                <label className="min-w-fit">From </label>
                <div className="grid">
                  <CustomDatePicker
                    className="w-[150px] h-[20px]"
                    format={"dd-MM-yyyy"}
                    name={"fromDate"}
                    // value={fromDate}
                    // handleChange={handleFromDateChange}
                    views={["year", "month", "day"]}
                    componentsProps={{
                      actionBar: { actions: ["clear"] },
                    }}
                    renderInput={(params) => (
                      <TextField
                        size="small"
                        InputLabelProps={{}}
                        {...params}
                        sx={{
                          backgroundColor: props.viewData && "#8080800f",
                        }}
                      />
                    )}
                  />
                  {/* <p className="text-red">{(fromError && !fromDate) && fromError}</p> */}
                </div>
              </Stack>
              <Stack className="ml-10">
                <label className="min-w-fit">To </label>
                <div className="grid">
                  <CustomDatePicker
                    className="w-[150px] h-[20px]"
                    format={"dd-MM-yyyy"}
                    name={"toDate"}
                    // value={toDate}
                    views={["year", "month", "day"]}
                    // minDate={new Date(fromDate).setDate(
                    //   new Date(new Date(fromDate).getTime()).getDate() + 30
                    // )}
                    // handleChange={handleToDateChange}
                    componentsProps={{
                      actionBar: { actions: ["clear"] },
                    }}
                    renderInput={(params) => (
                      <TextField
                        size="small"
                        InputLabelProps={{}}
                        {...params}
                        sx={{
                          backgroundColor: props.viewData && "#8080800f",
                        }}
                      />
                    )}
                  />
                  {/* <p className="text-red">{toError && !toDate && toError}</p> */}
                </div>
              </Stack>
            </>
          </div>
        </div>
      </Stack>

      <AgGridTable
        gridRef={gridRef}
        rowData={rowData}
        columnDefs={columnDefs}
        onGridReady={onGridReady}
        onSelectionChanged={onSelectionChanged}
        detailCellRendererParams={detailCellRendererParams}
        masterDetail={true}
        isRowMaster={isRowMaster}
        groupCheckBox={false}
        rowSelection={"single"}
        hideCheckbox={true}
        saveGridStateName={"financing"}
      />
      {/* dialog box */}
      <Dialog
        open={open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <AppBar position="static">
          <Toolbar className="flex w-full justify-between">
            <Typography variant="subtitle1" color="inherit">
              Finance Invoice
            </Typography>
            <IconButton onClick={handleClose}>
              <FuseSvgIcon>heroicons-solid:x</FuseSvgIcon>
            </IconButton>
          </Toolbar>
        </AppBar>

        <DialogTitle>
          <div className="flex flex-col sm:flex-row space-y-16 sm:space-y-0">
            <span>Genarate SI & PI Invoice</span>
          </div>
        </DialogTitle>
        <DialogContent sx={{width: 400}}>
          <div className="flex items-center">
            <span className="mr-5">Sales Invoice</span>
            <p> {invoice.salesInvoice}</p>
            <IconButton onClick={handleClickSalesInvoice}>
              <FuseSvgIcon>heroicons-outline:external-link</FuseSvgIcon>
            </IconButton>
          </div>
          <div className="flex items-center">
          <span  className="mr-5">Purchase Invoice</span>
          <p>{invoice.purchaseInvoice}</p>
            <IconButton onClick={handleClickPurchaseInvoice}>
              <FuseSvgIcon>heroicons-outline:external-link</FuseSvgIcon>
            </IconButton>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default FinanceInvoice;
